import React from 'react';
import {
    Alert,
    Box,
    Chip,
} from '@mui/material';
import { CheckCircle, Warning } from '@mui/icons-material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { MaintenanceSchedule } from '../../types/cutterHistory';

interface CutterDetailsHistoryPlanProps {
    commonDataGridProps: any;
    schedule: MaintenanceSchedule[];
}

const scheduleColumns: Array<GridColDef<MaintenanceSchedule>> = [
    { field: 'serviceName', headerName: 'Service', flex: 1, minWidth: 160 },
    {
        field: 'scheduleDate', headerName: 'Reported', flex: 1, minWidth: 120,
        valueFormatter: (value?: string) => value ? new Date(`${value}Z`).toLocaleDateString() : '',
    },
    {
        field: 'isOverdue',
        headerName: 'Status',
        align: 'center',
        minWidth: 50, 
        flex: 1,
        renderCell: ({ row }: GridRenderCellParams<MaintenanceSchedule, boolean>) => {
            if (row.isOverdue)
                return <Chip icon={<Warning />} label="Overdue" color="error" size="small" />;
            if (row.daysRemaining != null && row.daysRemaining <= 30)
                return <Chip icon={<Warning />} label="Due soon" color="warning" size="small" />;
            return <Chip icon={<CheckCircle />} label="OK" color="success" size="small" />;
        },
    },
    {
        field: 'daysRemaining',
        headerName: 'Days remaining',
        minWidth: 110, flex: 1,
        type: 'number',
        renderCell: ({ value }: GridRenderCellParams<MaintenanceSchedule, number>) => {
            if (value == null) return null;
            const color = value <= 0 ? 'error.main' : value <= 30 ? 'warning.main' : 'text.primary';
            return <Box sx={{ color, fontWeight: value <= 30 ? 600 : 400 }}>{value}</Box>;
        },
    },
    {
        field: 'wearPercent',
        headerName: 'Wear %',
        minWidth: 70, flex: 1,
        type: 'number',
        valueFormatter: (value?: number) => (value != null ? `${value}%` : ''),
    },
];

const commonGridSx = {
    border: 'none',
    minWidth: 0,
    width: '100%',
    '& .MuiDataGrid-columnHeaders': { backgroundColor: 'transparent' },
};

export const CutterDetailsHistoryPlan: React.FC<CutterDetailsHistoryPlanProps> = ({
    schedule,
    commonDataGridProps
}) => {

    return (
            schedule.length === 0 ? (
                <Alert severity="info">No scheduled maintenance available for this cutter.</Alert>
            ) : (
                <DataGrid
                    {...commonDataGridProps}
                    rows={schedule}
                    columns={scheduleColumns}
                    getRowId={(row) => row.id}
                    density="compact"
                    disableRowSelectionOnClick
                />
            )
    );
};

export default CutterDetailsHistoryPlan;
